import { upload } from 'src/helpers/uploadDocument';
import moment from 'moment';

export interface DocumentApiData {
  ItemId: string;
  Name: string;
  Type: string;
  Data: string;
  UserId: string;
  isImportantDocument?: boolean;
  DocAvailableSuiteLevel?: boolean;

  [key: string]: any;
}

export interface DocumentFormData {
  docAvailability?: boolean;
  isImportantDocument?: boolean;
  type?: string;
  name?: string;
  description?: string;
  image?: any;
  uploadType?: string;
  Embed?: string;
  pendingFile?: any;
  [key: string]: any;
}

// Processes a document with pendingFile for upload. Uploads file to S3 and returns updated document with image URL.
export const prepareDocumentForApiUploadToS3 = async (
  document: DocumentFormData,
  itemId: string,
  userId: string,
  additionalData: Record<string, any> = {}
): Promise<DocumentApiData | null> => {
  try {
    let processedDocument: DocumentFormData = document;

    // Process pendingFile if it exists.
    if (document?.pendingFile?.path) {
      const path: string = document.pendingFile.path;
      const newFileName: string =
        path.split(/\.(?=[^\.]+$)/)[0] +
        moment().format('MMDDYYYYhmmss') +
        '.' +
        path.split(/\.(?=[^\.]+$)/)[1];

      // Get the file object from pendingFile + upload to S3.
      const fileToUpload = document.pendingFile.file || document.pendingFile;
      const image = await upload(fileToUpload, newFileName.replace(/ /g, ''));

      // Remove pendingFile and set the image property with S3 URL.
      const { pendingFile, ...rest } = document;

      processedDocument = {
        ...rest,
        image,
        name: document.name || newFileName,
      };
    }

    // Remove uploadType from the data to be saved.
    const { uploadType, ...documentData } = processedDocument;

    // Prepare the final API data object for API submission.
    return {
      ItemId: itemId,
      Name: 'DOCUMENTS',
      Type: 'DOCUMENTS',
      Data: JSON.stringify(documentData).toString(),
      UserId: userId,
      isImportantDocument: processedDocument.isImportantDocument,
      DocAvailableSuitelevel: processedDocument.docAvailability,
      ...additionalData, // Include any additional data provided by the component.
    };
  } catch (error) {
    console.error('Error preparing document for API:', error);
    return null;
  }
};
